export default __webpack_public_path__ + "static/media/Web_semanasanta_moto_330x330.8c0c89bd.png";